import { ApiError } from "api/types";
import { useCustomMutation } from "api/useCustomMutation";
import { JANZU_URL } from "config/config";

const useResetOnboardingsMutation = () => useCustomMutation(`${JANZU_URL}device-api/reset-onboardings`, "PATCH");

type UseOnboardingsReturn = {
  // Reset operations
  resetOnboardings: () => void;
  resetOnboardingsAsync: () => Promise<unknown>;
  isResettingOnboardings: boolean;
  resetOnboardingsError: ApiError | null;
};

export function useOnboardings(): UseOnboardingsReturn {
  const resetOnboardingsMutation = useResetOnboardingsMutation();

  return {
    // Reset operations
    resetOnboardings: () => resetOnboardingsMutation.mutate(),
    resetOnboardingsAsync: () => resetOnboardingsMutation.mutateAsync(),
    isResettingOnboardings: resetOnboardingsMutation.isLoading,
    resetOnboardingsError: resetOnboardingsMutation.error,
  };
}
